import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { FootnoteForm } from '@/forms/FootnoteForm/FootnoteForm'
import { Settings } from '@/interfaces/Settings'

export default function SettingsFootnotePage() {
  const { data: settings, isLoading } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Text v patičce"
      description="Text, který se vytiskne na konec každé faktury a výzvy k platbě."
      breadcrumbHref="/settings/footnote"
    >
      {isLoading && <Loading />}

      {settings && <FootnoteForm defaultValues={{ footnote: settings.footnote ?? '' }} />}
    </SettingsPage>
  )
}
